import { createFileRoute } from "@tanstack/react-router";
import { ClosedLoopWorkspace } from "@/components/AdditionalWorkspaces";

export const Route = createFileRoute("/closed-loop")({ component: ClosedLoopWorkspace });
